/**
 * This is useful at the end of a chain of `??` when the chances of hitting the end of the chain are slim.
 */
export function never(errorMessage: string): never {
  throw new Error(errorMessage);
}
